import React from 'react'
import AdminNavbar from './AdminNavbar'
import AdminPanel from './AdminPanel'

const AdminDashboard = () => {
    return (
        <div className='admin'>
            <AdminNavbar />
            <AdminPanel/>
            </div>
    )
}

export default AdminDashboard